import store from "@/store/store";
import axios from "@/axios";
import events from "@/events/events";
import {annotation} from "@/class/annotation/annotation";

export class link{
    
    objectType = null;
    content = null;
    deleted = null;
    
    getId(){
        if(this.objectType === null) return 0;
        return this.content.getId();
    }
    setId(pk){
        this.pk = pk;
        return this;
    }
    setData(obj, storyId){
        
        this.objectType = obj.getObjectType();
        this.content = obj;
        if(storyId){
            this.content.setStoryId(storyId)
        }
        this.deleted = null;
    
        return this;
    }
    getThumbnail(){
        if(!this.exist()) return store.getters.getDefault("BaseImage");
        
        this.content.getThumbnail();
    }
    getTitle(){
        if(!this.exist()) return "Not linked";
        
        if(this.objectType === "annotation"){
            return this.content.text.substr(0,40)+"...";
        }
        
        return this.content.getName();
    }
    getIco(){
        if(!this.exist()) return "fa-ban";
        return store.getters.iconByType(this.objectType);
    }
    
    exist(){
        return this.objectType !== null;
    }
    
    async delete(){
        this.deleted = this.objectType;
        this.objectType = null;
        this.content = null;
    }
    
    is(type){
        // console.log(this.content.constructor.name)
        return this.objectType === type;
    }
    
    load(data){
        store.getters.getGlobalInfoLink.forEach(async content => {
            let name = content.linkName || content.type;
            if(data[name] !== null && typeof data[name] === "object"){
                let contentClass = new content.class();
                await contentClass.setDataReq(data[name],true)
                this.content = contentClass;
                this.objectType = this.content.getObjectType();
            }
        })
    }
    
    getDataReq(){
        let data = {}
        
        if(this.deleted !== null){
            data[this.deleted] = null;
            return data;
        }
        
        store.getters.getGlobalInfoLink.forEach(content => {
            let name = content.linkName || content.type;
            if(this.objectType === content.type) {
                data[name] = this.content.getId();
            }
        })
        
        return data;
    }
    
    toReq(){
        let data = {}
        store.getters.getGlobalInfoLink.forEach(content => {
            let name = content.linkName || content.type;
            if(this.objectType === content.type) {
                data[name] = this.content.toReq();
            }else{
                data[name] = null;
            }
        })
        return data;
    }
}